import { useCallback, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { saveCoordinatCustomer, } from '../../Store/Actions/booking';
import { useNavigate } from 'react-router-dom';
import LeafletNearestDrivers from '../../Components/LeafletNearestDrivers';
import { AppDispatch } from '../../Store/Reducers';
import { isEmpty } from '../../Utils/string';
import Spinner from '../../Components/Spinner';

const NearestDriversMobile = () => {
    const dispatch: AppDispatch = useDispatch();
    const navigate = useNavigate();
    const { dataOrderRide } = useSelector((state: any) => state.userReducer);

    const [customerData, setCustomerData] = useState<any | null>(null);
    const [driverData, setDriverData] = useState<any | null>(null);

    // saveCoordinatCustomer
    const fetchDriver = useCallback(async () => {
        if (customerData) await dispatch(saveCoordinatCustomer(customerData));
    }, [dispatch, customerData]);

    useEffect(() => {
        fetchDriver();
    }, [fetchDriver, customerData]);
    // ================================================

    // 1. pertama kali aplikasi di buka -> cek orderan
    useEffect(() => {
        if (dataOrderRide?.data?.[0]?.status === "Tunda" || dataOrderRide?.data?.[0]?.status === "Terima") {
            navigate(`/orderDriverTrace`);
        }
    }, [dataOrderRide, navigate]);


    // const postToReactNative = () => {
    //     if (window.ReactNativeWebView?.postMessage) {
    //         window.ReactNativeWebView.postMessage(
    //             JSON.stringify({
    //                 type: `DRIVER_DATA`,
    //                 payload: {
    //                 },
    //             })
    //         );
    //     }
    // };

    // 1. Terima driver dan customer lokasi
    useEffect(() => {
        document.addEventListener('message', (event: any) => {
            const receivedData = JSON.parse(event.data);
            if (receivedData.type === 'DRIVERS_CUSTOMER_PAYLOAD') {
                setDriverData(receivedData?.payload?.drivers);
                setCustomerData(receivedData?.payload?.customer);
            }
        });
    }, []);

    return (
        <>
            {/* <HeaderMobile /> */}
            {isEmpty(driverData) && isEmpty(customerData) ? (
                <Spinner />
            ) : (
                <LeafletNearestDrivers
                    isShowHandleDriverClick={true}
                    customer={customerData}
                    drivers={driverData}
                    zoom={14}
                    isReverseGeocode={false}
                    height="100vh"
                />
            )}
        </>
    );
}

export default NearestDriversMobile;